// Brand-wide constants: socials, contact, hero image, etc.
export const BRAND = {
  whatsapp: '573156715822',
  instagram: 'jellyupmamacita',
  tiktok: 'jellyupmamacita',
  email: 'jelly@jellyupmamacita.com',
  whatsappDisplay: '+57 315 671 5822',
  hashtag: '#JellyGirlies',
};

export const WHATSAPP_LINK = (text = '') =>
  `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(text)}`;

export const IMAGES = {
  hero: 'https://static.prod-images.emergentagent.com/jobs/93dff7f6-cd91-4270-868b-3a0f334ab54a/images/8fc658486127825dbed671831e9b257369c43b11f929fa8f2c2b6d49b273140b.png',
  jellyBg: 'https://static.prod-images.emergentagent.com/jobs/93dff7f6-cd91-4270-868b-3a0f334ab54a/images/4805684e48ab3d2b23046b3e8a764f34e50c24e39fbad8b70ee8616c8a5393b4.png',
  tiktokThumb: 'https://static.prod-images.emergentagent.com/jobs/93dff7f6-cd91-4270-868b-3a0f334ab54a/images/e8ea85eb2d52c3e1762afd89e927d22df6e01f354d220c78aa2bfc327174fa87.png',
  socialFeed1: 'https://static.prod-images.emergentagent.com/jobs/93dff7f6-cd91-4270-868b-3a0f334ab54a/images/1543bf90f5cae35dad9dff5c1b7b937a92422d6cb45332f01be75b19be53d5e1.png',
  socialFeed2: 'https://static.prod-images.emergentagent.com/jobs/93dff7f6-cd91-4270-868b-3a0f334ab54a/images/c0e7deac6efbe7b984d180eb2f9852c801d0b22226832cb181eb7c997c92ffab.png',
  textureSmear: 'https://images.pexels.com/photos/6550713/pexels-photo-6550713.jpeg',
  brandLifestyle: 'https://images.pexels.com/photos/6784744/pexels-photo-6784744.jpeg',
};

// Diversity gallery — "Para toda piel" section
export const DIVERSITY_GALLERY = [
  { src: 'https://images.pexels.com/photos/6651650/pexels-photo-6651650.jpeg', tone: 'light', tag: { es: 'Piel clara', en: 'Light skin' } },
  { src: 'https://images.pexels.com/photos/31249232/pexels-photo-31249232.jpeg', tone: 'light', tag: { es: 'Pecas', en: 'Freckles' } },
  { src: 'https://images.pexels.com/photos/21849239/pexels-photo-21849239.jpeg', tone: 'light-medium', tag: { es: 'Piel media', en: 'Medium skin' } },
  { src: 'https://images.pexels.com/photos/15405059/pexels-photo-15405059.jpeg', tone: 'medium', tag: { es: 'Glow editorial', en: 'Editorial glow' } },
  { src: 'https://images.pexels.com/photos/9256869/pexels-photo-9256869.jpeg', tone: 'medium-tan', tag: { es: 'Acabado dewy', en: 'Dewy finish' } },
  { src: 'https://images.pexels.com/photos/36143086/pexels-photo-36143086.jpeg', tone: 'tan', tag: { es: 'Piel canela', en: 'Tan skin' } },
  { src: 'https://images.pexels.com/photos/31282938/pexels-photo-31282938.jpeg', tone: 'deep', tag: { es: 'Piel oscura', en: 'Deep skin' } },
  { src: 'https://images.pexels.com/photos/3973709/pexels-photo-3973709.jpeg', tone: 'deep', tag: { es: 'Confidence', en: 'Confidence' } },
];

export const SOCIAL_FEED = [
  { src: 'https://customer-assets.emergentagent.com/job_jelly-vibes/artifacts/lpywfdca_IMG_8954.png', type: 'image', caption: 'Zero Drama Mama!' },
  { src: IMAGES.socialFeed1, type: 'image', caption: 'Jelly Girlies' },
  { src: 'https://customer-assets.emergentagent.com/job_jelly-vibes/artifacts/bvx94g2q_IMG_8955.png', type: 'image', caption: 'Filtro Real · N°2' },
  { src: 'https://customer-assets.emergentagent.com/job_jelly-vibes/artifacts/52ujn3w2_IMG_8956.png', type: 'image', caption: 'Sun Suavecito' },
  { src: IMAGES.tiktokThumb, type: 'video', caption: 'GRWM con Jelly' },
  { src: 'https://customer-assets.emergentagent.com/job_jelly-vibes/artifacts/7kisj02v_IMG_8957.png', type: 'image', caption: 'S.O.S Labios' },
];
